import { BackButton } from "@/components/shared";
import { ArchMark } from "@/components/marks";
import { images } from "@/lib/constants";

export function DispatchPage() {
  return (
    <div className="pt-40 pb-24 px-6 md:px-12 max-w-5xl mx-auto animate-in fade-in duration-700">
      <BackButton />
      <div className="text-[10px] font-bold tracking-[0.3em] mb-4 text-[#C06B5D] border-b border-[#C06B5D] pb-4 inline-block">OCTOBER 2025 • DISPATCH 04</div>
      <h1 className="font-serif text-5xl md:text-7xl uppercase mb-16">Pouring the Private Pavilions</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
        <div className="bg-[#ECE9E0] border border-[#293129]/20 p-2">
          <img src={images.archConstruction} alt="Blueprint" className="w-full h-80 object-cover grayscale text-transparent" />
        </div>
        <div className="flex flex-col justify-center px-4 md:px-12">
          <ArchMark className="w-16 h-16 text-[#8F9B82] mb-8" />
          <h3 className="font-serif text-3xl mb-4">The Architectural Signature</h3>
          <p className="tracking-widest uppercase text-xs leading-loose opacity-80">
            The structural skeleton of the leisure club relies on a repeating adobe archway motif. This provides massive thermal inertia, keeping the interiors cool during the peak summer days.
          </p>
        </div>
      </div>
    </div>
  );
}
